import React, {useContext} from 'react';
import NavBar from './NavBar'
import AuthContext from '../../context/authContext/authContext';

import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    CssBaseline,
    Typography,
    Box,
    Link
 
} from '@material-ui/core';


const styles = makeStyles((theme) =>({
    container : {
        height : '35vh',
        backgroundColor : 'black' ,
        display : 'flex',
        justifyContent : 'center'
    },
    footer : {
        position : 'fixed',
        bottom : 0,
        width: '100%',
        heigth : '25vh',
        backgroundColor :'black',
       
    },
    logo: {
        width: '30%',
        display: 'block',
        margin : 'auto'
    }
    
}));

const Layout = (props) => {
    const classes = styles(props)
    const authContext = useContext(AuthContext);
    const {cliente} = authContext;
   
    
    return ( 
        <>
         <CssBaseline/>
            <NavBar history={props.history} setActiveStep = {props.setActiveStep}/>
            <Grid container  className={classes.container} direction="column"
                justify="center"
                alignItems="center">
            <Grid>
                <img className={classes.logo} alt="logo Pila" src='./logo.png'></img>
            </Grid>
            <Grid>
                <Typography componente='h3' variant='h4' color='secondary' align='center'>
                    Hola {cliente ? cliente.nombre : null}
                </Typography>
                <Typography  componente='h3' variant='h6'color='secondary' align='center'>
                    {props.title}
                </Typography>
            </Grid>
        </Grid>
        {props.children}
        <Box  className={classes.footer} mt={5} p={3}>
                        <Typography variant="body2" color="secondary" align="center">
                            {'Copyright © '}
                        <Link to={'/'} color="inherit" href="#">
                                Pila Cerveceria 
                        </Link>{' '}{new Date().getFullYear()}{'.'}
                        </Typography>
                        <Typography variant="body2" color="secondary" align="center">
                                Powered By AguileraWebDeveloper
                        </Typography>
                    </Box>
        </>
     );
}
 
export default Layout;
